import axios from "axios";
import endpoints from "../utils/endpoints";
import { accessToken } from "../utils/token";

const getAllContent = async (params: any) => {
  const url = endpoints.BLOG_CONTENT;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
    params: params,
  });

  return response;
};

const getContentType = async () => {
  const url = endpoints.BLOG_CONTENT + '/type';

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    }
  });

  return response;
};

const getContentById = async (id: number) => {
  const url = endpoints.BLOG_CONTENT + "/" + id;

  const { data: response } = await axios.get(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const create = async (params: any) => {
  const url = endpoints.BLOG_CONTENT;

  const { data: response } = await axios.post(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const update = async (params: any) => {
  const url = endpoints.BLOG_CONTENT + "/" + params.get('id');
  const { data: response } = await axios.put(url, params, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const deleteContent = async (id: number) => {
  const url = endpoints.BLOG_CONTENT + "/" + id;

  const { data: response } = await axios.delete(url, {
    headers: {
      Authorization: accessToken,
    },
  });

  return response;
};

const contentService = {
  getAllContent,
  create,
  update,
  deleteContent,
  getContentById,
  getContentType
};

export default contentService;
